// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"426":"82510d2e","938":"6a2a0bb3"}[chunkId] + ".chunk.js";
};